module.exports = __webpack_public_path__ + "assets/img/icon-moban-hot.faad57ad.png";